// extracted by mini-css-extract-plugin
export default {"name":"styles_name__IWRrJ","link":"styles_link__XRqRo"};